// ThemeContext.js
import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const ContextProvider = ({ children }) => {
  const [breadCrumb, setBreadCrumb] = useState([]);
  const [nestedHeader, setNestedHeader] = useState(null);
  const [collapseSideBar, setCollapseSideBar] = useState(false);
  const [openLoginPopup, setOpenLoginPopup] = useState(false);
  const [role, setRole] = useState("");
  const [orgFolderContentsAccountsPage, setOrgFolderContentsAccountsPage] = useState(null)

  return (
    <AppContext.Provider
      value={{
        breadCrumb,
        nestedHeader,
        openLoginPopup,
        collapseSideBar,
        setBreadCrumb,
        setNestedHeader,
        setOpenLoginPopup,
        setCollapseSideBar,
        role,
        setRole,
	    orgFolderContentsAccountsPage,
		setOrgFolderContentsAccountsPage,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useContextState = () => useContext(AppContext);
